<template>
  <div class="posterList">
    <swiper id="gallerys" class="swiper gallery-top" slides-per-view="auto" :options="swiperOptions" ref="swiper">
      <template v-for="(item, index) in list">
        <swiper-slide :style="{ width: item.imgWidth + 'px' }" :key="index">
          <div class="items" @click="toDetails(item.id, item.t_id)">
            <div class="cardDiv" :style="{ backgroundImage: 'url(' + item.cover_img + ')' }" />
            <img class="cardImg" :data-original="item.cover_img" :src="item.cover_img || defaultImg" :alt="item.name" @error="imgError(item)">
            <div class="marsk flex end" :data-id="item.id">
              <div class="u-info">
                <div class="title txt-el" :title="item.title">{{ item.title }}</div>
                <div class="subs flex">
                  <span class="txt-el">{{ item.organizer }}</span>
                </div>
              </div>
            </div>
          </div>
        </swiper-slide>
      </template>
    </swiper>
    <div class="swiper-button-next"></div>
    <div class="swiper-button-prev"></div>
  </div>
</template>

<script>
import utils from "@/utils"
import { swiper, swiperSlide } from "vue-awesome-swiper";
export default {
  components: {
    swiper,
    swiperSlide
  },
  filters: {
    date(val) {
      return utils.formatDates(val)
    },
  },
  props: {
    list: Array
  },
  data() {
    return {
      swiperOptions: {
        loop: false,
        slidesPerView: 'auto',
        initialSlide: 0,
        spaceBetween: 0,
        observer: true,
        freeMode: true,
        observeParents: true,
        navigation: {
          nextEl: '.posterList .swiper-button-next',
          prevEl: '.posterList .swiper-button-prev'
        },
      },
    }
  },
  mounted() {

  },
  methods: {
    toDetails(id, t_id) {
      this.$emit('toDetails', {id, t_id})
    },
  }
}
</script>
<style lang="scss" scoped>
.posterList {
  position: relative;
  padding: 0 40px;
  .items {
    position: relative;
    margin: 0 6px 12px;
    height: 325px;
    box-sizing: border-box;
    position: relative;
    flex-grow: 1;
    overflow: hidden;
    cursor: pointer;
    transition: all 0.3s;

    &:hover {
      box-shadow: 0 4px 10px 0 #0000004d;

      .cardDiv {
        transform: scale(1.1)
      }
    }

    .cardImg {
      display: block;
      height: 100%;
      opacity: 0;
    }

    .cardDiv {
      position: absolute;
      left: 0;
      top: 0;
      right: 0;
      bottom: 0;
      /* display: block; */
      background-repeat: no-repeat;
      background-position: center;
      background-size: cover;
      transition: all 0.3s;
    }
  }

  .swiper-button-next,
  .swiper-button-prev {
    width: 20px;
    height: 34px;
    // left: 50%;
    transition: all 0.35s;
    top: 50%;
    opacity: .35;
    background: url(~@/assets/images/arrow2.png) center center no-repeat;

    &.swiper-button-prev {
      background: url(~@/assets/images/arrow1.png) center center no-repeat;
    }

    &::after {
      display: none;
    }

    &:not(.swiper-button-disabled) {
      &:hover {
        opacity: 1;
      }
    }
  }

  .swiper-button-next {
    right: 0;
  }

  .swiper-button-prev {
    left: 0;
  }
}</style>